import jsonToJsxComponent from '../jsonToJsxComponent';
import NewsCardJson from './NewsCard.json';
import NewsPanelJson from './NewsPanel.json';

const NewsCard = jsonToJsxComponent(NewsCardJson);
const NewsPanel = jsonToJsxComponent(NewsPanelJson);

export { NewsCard, NewsPanel };
